<div class="modal">
    <div class="modal-content">
        <ion-text class="loading-text" [innerHTML]="(options$ | async).message"></ion-text>
        <ng-container *ngIf="(options$ | async).dataType === 'media'">
            <ion-progress-bar [value]="((options$ | async).progress$ | async)" #progress type="determinate" color="danger"></ion-progress-bar>
        </ng-container>
    </div>
</div>
